// Generated by scripts/icons/build-icon-components.mjs from the matching
// file in ./svg — edit the SVG and re-run the script, not this file.
import SvgIcon, { type SvgIconProps } from '@mui/material/SvgIcon';

const ShowIcon = (props: SvgIconProps) => (
  <SvgIcon viewBox="0 0 24 24" {...props}>
    <g fill="currentColor">
      <path
        d="M12 3.6c2.17 0 4.23.75 6.02 2.15 1.8 1.38 3.32 3.4 4.42 5.94q.12.31 0 .6c-2.2 5.08-6.1 8.11-10.44 8.11h-.01c-4.33 0-8.24-3.03-10.43-8.1q-.12-.3 0-.6C3.76 6.61 7.66 3.6 12 3.6m0 4.33c-2.26 0-4.1 1.82-4.1 4.07s1.84 4.06 4.1 4.06 4.09-1.82 4.09-4.06c0-2.25-1.84-4.07-4.09-4.07"
        opacity=".5"
      />
      <path d="M14.55 12c0 1.4-1.14 2.53-2.55 2.53S9.44 13.4 9.44 12q0-.26.05-.5h.05c1.14 0 2.06-.9 2.1-2.02l.36-.03c1.4 0 2.55 1.14 2.55 2.55" />
    </g>
  </SvgIcon>
);

export default ShowIcon;
